import { makeAutoObservable } from 'mobx'
import * as API from '../../service/api/LoginApi'
import { TOKEN_KEY } from 'service/config'

class LoginStore {
  constructor() {
    makeAutoObservable(this)
  }

  getCaptcha = async () => {
    return await API.GET_CAPTCHA()
  }

  userLogin = async (data) => {
    let res = await API.USER_LOGIN(data)
    if (res.code === 0) {
      sessionStorage.setItem(TOKEN_KEY, res.data.token)
    }
    return res
  }

  userInfo = async () => {
    let res = await API.USER_INFO()
    // if (res.code === 0) {
    //   sessionStorage.setItem(TOKEN_KEY, res.data.token)
    // }
    return res
  }

  userLogout = async () => {
    let res = await API.USER_LOGOUT()
    sessionStorage.removeItem(TOKEN_KEY)
    return res
  }
}

export default new LoginStore()
